import React from 'react'
import { observer } from 'mobx-react-lite'
import { FieldDropdown } from 'shared/ui'
import { SendFrom } from 'widgets/SendFrom'
import { type CampaignSendFromStore } from './store/CampaignSendFromStore'

type ICampaignSMSProps = {
  store: CampaignSendFromStore
}

export const CampaignSendFrom = observer(({ store }: ICampaignSMSProps) => {
  return (
    <FieldDropdown
      labelText={'Send from'}
      dropdownComponent={
        <SendFrom
          store={store.sendFromStore}
          triggerVariant={'textField'}
          textFiledTriggerProps={{
            error: {
              message: store.error,
            },
          }}
          onClearError={() => store.setError('')}
        />
      }
    />
  )
})
